<div class="app-container">
  <app-side-nav></app-side-nav>
  <div class="main-content" [class.no-header]="hideHeader">
    @if (!hideHeader) {
      <app-header></app-header>
    }
    <router-outlet></router-outlet>
  </div>
</div>
